export default {
      id: "logo_menu-usage",
      viewBox: "0 0 105 44",
      url: "../dist/images/" + "sprite.svg#logo_menu-usage",
      toString: function () {
        return this.url;
      }
    }